__turbopack_context__.v({
  "additionalText": "style-module-scss-module___U_MBG__additionalText",
  "awards": "style-module-scss-module___U_MBG__awards",
  "awardsContent": "style-module-scss-module___U_MBG__awardsContent",
  "awardsItem": "style-module-scss-module___U_MBG__awardsItem",
  "awardsMobile": "style-module-scss-module___U_MBG__awardsMobile",
  "button": "style-module-scss-module___U_MBG__button",
  "content": "style-module-scss-module___U_MBG__content",
  "head": "style-module-scss-module___U_MBG__head",
  "info": "style-module-scss-module___U_MBG__info",
  "list": "style-module-scss-module___U_MBG__list",
  "listItem": "style-module-scss-module___U_MBG__listItem",
  "mobileItem": "style-module-scss-module___U_MBG__mobileItem",
  "title": "style-module-scss-module___U_MBG__title",
  "type": "style-module-scss-module___U_MBG__type",
});
